/**
 * 菜单配置模块
 * 集中管理所有菜单配置项
 */

/**
 * 菜单项接口
 */
export interface MenuItem {
  name: string;
  routerName: string;
  permission?: string;
  // 仅当用户信息存在非空 companyStudioDomainName 字段时才显示该菜单
  requiresStudioDomain?: boolean;
}

/**
 * 默认主页菜单配置（非企业版或未启用权限路由时使用）
 */
export const DEFAULT_HOME_MENU: MenuItem[] = [
  { name: '广场', routerName: 'home' },
  { name: '对话', routerName: 'app' },
  // { name: '绘画', routerName: 'paintPic' },
  { name: '插件', routerName: 'plugin' },
  // { name: '模型', routerName: 'models' },
  { name: '模板', routerName: 'template' },
  { name: '创作', routerName: 'creation', requiresStudioDomain: true },
];

/**
 * 企业版菜单配置（启用权限路由时使用）
 */
export const ENTERPRISE_MENU_CONFIG: MenuItem[] = [
  { name: '首页', routerName: 'home', permission: 'homePage' },
  { name: '对话', routerName: 'app' }, // 无权限标识表示默认显示
  // { name: '绘画', routerName: 'paintPic', permission: 'paintPage' },
  { name: '插件', routerName: 'plugin', permission: '/console/plugins' },
  // { name: '模型', routerName: 'models', permission: '/console/model' },
  { name: '模板', routerName: 'template', permission: 'appTemplate' },
  { name: '广场', routerName: 'square', permission: 'squarePage' },
  { name: '创作', routerName: 'creation', requiresStudioDomain: true },
];

/**
 * 会员等级枚举
 */
export enum MemberGrade {
  FREE = 'FREE',
  NORMAL = 'NORMAL',
  PROFESSION = 'PROFESSION',
  ENTERPRISE = 'ENTERPRISE',
}

